export const EscrowHelperAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'escrow', internalType: 'address', type: 'address' },
      { name: 'vault', internalType: 'address', type: 'address' },
      {
        name: 'additionalCurrencies',
        internalType: 'Currency[]',
        type: 'address[]',
      },
    ],
    name: 'escrowBalancesOf',
    outputs: [
      {
        name: 'balances',
        internalType: 'struct EscrowHelper.Balances',
        type: 'tuple',
        components: [
          { name: 'snapshots', internalType: 'uint256[]', type: 'uint256[]' },
          {
            name: 'snapshotBalances',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
          { name: 'currencies', internalType: 'address[]', type: 'address[]' },
          {
            name: 'currencyBalances',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'messenger', internalType: 'address', type: 'address' },
      { name: 'messages', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'escrow', internalType: 'address', type: 'address' },
      { name: 'bridging', internalType: 'Currency', type: 'address' },
    ],
    name: 'estimateBridgingAmount',
    outputs: [{ name: 'bridgingBalance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'escrowDeployer', internalType: 'address', type: 'address' },
      { name: 'bridgingToken', internalType: 'address', type: 'address' },
      { name: 'bridgingAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'payload', internalType: 'bytes', type: 'bytes' },
      {
        name: 'additionalStorageActionAmount',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'estimateHomeMessageGas',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'messenger', internalType: 'address', type: 'address' },
      { name: 'messages', internalType: 'bytes[]', type: 'bytes[]' },
    ],
    name: 'estimateMessagesGas',
    outputs: [{ name: 'results', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'escrowDeployer', internalType: 'address', type: 'address' },
      { name: 'vault', internalType: 'address', type: 'address' },
      {
        name: 'additionalCurrencies',
        internalType: 'Currency[]',
        type: 'address[]',
      },
    ],
    name: 'userBalancesOf',
    outputs: [
      {
        name: 'balances',
        internalType: 'struct EscrowHelper.Balances',
        type: 'tuple',
        components: [
          { name: 'snapshots', internalType: 'uint256[]', type: 'uint256[]' },
          {
            name: 'snapshotBalances',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
          { name: 'currencies', internalType: 'address[]', type: 'address[]' },
          {
            name: 'currencyBalances',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
        ],
      },
      { name: 'escrow', internalType: 'address', type: 'address' },
      { name: 'deployed', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
] as const
